<template>
  <div class="video-audit-container">
    <!-- 标题 -->
    <h2>视频审核管理</h2>

    <!-- 搜索栏 -->
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="8">
        <el-input
            v-model="searchForm.videoName"
            placeholder="请输入视频名称"
            clearable
        />
      </el-col>
      <el-col :span="8">
        <el-select
            v-model="searchForm.status"
            placeholder="审核状态"
            clearable
        >
          <el-option label="待审核" :value="0" />
          <el-option label="已通过" :value="1" />
          <el-option label="已拒绝" :value="2" />
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-button type="primary" @click="searchVideos">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-col>
    </el-row>

    <!-- 视频列表 -->
    <el-table :data="videoList" border style="width: 100%">
      <!-- 视频预览 -->
      <el-table-column label="视频预览" width="220">
        <template v-slot="{ row }">
          <video
              :src="row.video_path"
              class="video-preview"
              controls
          />
        </template>
      </el-table-column>

      <!-- 视频信息 -->
      <el-table-column prop="videoName" label="视频名称" />

      <el-table-column label="审核状态" width="100">
        <template v-slot="{ row }">
          <el-tag :type="getStatusType(row.showing)">
            {{ getStatusText(row.showing) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="createdAt" label="上传时间" width="180" />

      <!-- 操作按钮 -->
      <el-table-column label="操作" width="200" fixed="right">
        <template v-slot="{ row }">
          <el-button
              v-if="row.showing === 0"
              type="success"
              size="small"
              @click="handleAudit(row.id, 1)"
          >通过</el-button>
          <el-button
              v-if="row.showing === 0"
              type="danger"
              size="small"
              @click="handleAudit(row.id, 2)"
          >拒绝</el-button>
          <el-button
              v-if="row.showing !== 0"

              type="success"
              size="small"
              @click="openEditDialog(row)"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        class="pagination"
        background
        layout="prev, pager, next, sizes, total"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
    />

    <!-- 编辑对话框 -->
    <el-dialog
        v-model="editDialogVisible"
        title="编辑视频审核状态"
        width="30%"
    >
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="审核状态">
          <el-select v-model="editForm.status" placeholder="请选择审核状态">
            <el-option label="待审核" :value="0" />
            <el-option label="已通过" :value="1" />
            <el-option label="已拒绝" :value="2" />
          </el-select>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from '@/axios'

export default {
  name: 'VideoAuditView',

  data() {
    return {
      searchForm: {
        videoName: '',
        status: '',
      },
      userid: this.$route.query.userid, // 获取路由中的用户id
      organizationID: this.$route.query.organizationID, // 获取路由中的机构id
      videoList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,

      // 编辑对话框相关数据
      editDialogVisible: false,
      editForm: {
        id: null,
        status: null,
      },
    }
  },

  methods: {
    // 获取视频列表
    async getVideoList() {
      try {
        const params = {
          page: this.currentPage,
          pageSize: this.pageSize,
          videoName: this.searchForm.videoName,
          status: this.searchForm.status,
          organizationId: this.organizationID,
        }
        const response = await axios.get('/videos/audit', { params })

        if (response.data.success) {
          this.videoList = response.data.data.list
          this.total = response.data.data.total
        } else {
          ElMessage.error(response.data.message || '获取视频列表失败')
        }
      } catch (error) {
        console.error('获取视频列表失败:', error)
        ElMessage.error('获取视频列表失败')
      }
    },

    // 处理审核
    async handleAudit(id, status) {
      try {
        const action = status === 1 ? '通过' : '拒绝'
        await ElMessageBox.confirm(`确定要${action}这个视频吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: status === 1 ? 'success' : 'warning',
        })

        const response = await axios.post('/videos/audit', {
          id,
          status,
        })

        if (response.data.success) {
          ElMessage.success(`视频${action}成功`)
          this.getVideoList() // 重新加载列表
        } else {
          ElMessage.error(response.data.message || `视频${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('审核操作失败:', error)
          ElMessage.error('审核操作失败')
        }
      }
    },

    // 打开编辑对话框
    openEditDialog(row) {
      this.editForm.id = row.id
      this.editForm.status = row.showing
      this.editDialogVisible = true
    },

    // 提交编辑
    async submitEdit() {
      try {
        const response = await axios.post('/videos/audit', {
          id: this.editForm.id,
          status: this.editForm.status,
        })

        if (response.data.success) {
          ElMessage.success('审核状态更新成功')
          this.editDialogVisible = false
          this.getVideoList() // 重新加载列表
        } else {
          ElMessage.error(response.data.message || '审核状态更新失败')
        }
      } catch (error) {
        console.error('审核状态更新失败:', error)
        ElMessage.error('审核状态更新失败')
      }
    },

    // 搜索视频
    searchVideos() {
      this.currentPage = 1
      this.getVideoList()
    },

    // 重置搜索
    resetSearch() {
      this.searchForm.videoName = ''
      this.searchForm.status = ''
      this.searchVideos()
    },

    // 页码改变
    handlePageChange(page) {
      this.currentPage = page
      this.getVideoList()
    },

    // 每页数量改变
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.getVideoList()
    },

    // 获取状态类型
    getStatusType(status) {
      const types = {
        0: 'info',
        1: 'success',
        2: 'danger',
      }
      return types[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const texts = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝',
      }
      return texts[status] || '未知'
    },
  },

  created() {
    this.getVideoList()
  },
}
</script>

<style scoped>
.video-audit-container {
  padding: 20px;
}

.video-preview {
  width: 200px;
  height: 120px;
  object-fit: cover;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-tag {
  margin-right: 8px;
}
</style>